export interface Category {
  name: string;
  url: string;
  icon: string;
  description: string;
}

export const categories: Category[] = [
  {
    name: 'Shoes',
    url: 'https://kaspreadsheet.com/category-911-Shoes.html',
    icon: 'ri-footprint-line',
    description: 'Browse the latest sneaker and shoe finds from top sellers. Updated daily with fresh QC-checked links.',
  },
  {
    name: 'Hoodies/Sweaters',
    url: 'https://kaspreadsheet.com/category-912-Hoodies%2FSweaters.html',
    icon: 'ri-t-shirt-line',
    description: 'Cozy hoodies and premium sweaters curated from trusted suppliers across all price ranges.',
  },
  {
    name: 'T-Shirts',
    url: 'https://kaspreadsheet.com/category-913-T-Shirts.html',
    icon: 'ri-shirt-line',
    description: 'Essential tees and graphic shirts handpicked for style, quality, and value in every budget tier.',
  },
  {
    name: 'Jackets',
    url: 'https://kaspreadsheet.com/category-914-Jackets.html',
    icon: 'ri-contrast-drop-2-line',
    description: 'Statement jackets and outerwear pieces that elevate any outfit from streetwear to luxury styles.',
  },
  {
    name: 'Pants/Shorts',
    url: 'https://kaspreadsheet.com/category-915-Pants%2FShorts.html',
    icon: 'ri-pantone-line',
    description: 'Trending bottoms collection featuring cargo pants, denim, shorts, and tailored trousers.',
  },
  {
    name: 'Headwear',
    url: 'https://kaspreadsheet.com/category-916-Headwear.html',
    icon: 'ri-user-3-line',
    description: 'Caps, beanies, bucket hats, and more to complete your fit with the perfect headpiece.',
  },
  {
    name: 'Sets',
    url: 'https://kaspreadsheet.com/category-917-Sets.html',
    icon: 'ri-stack-line',
    description: 'Coordinated clothing sets and matching outfits that take the guesswork out of styling.',
  },
  {
    name: 'Underwear/Underpants',
    url: 'https://kaspreadsheet.com/category-918-underwear%2Funderpants.html',
    icon: 'ri-checkbox-blank-line',
    description: 'Quality essentials and basics sourced from reliable vendors with consistent sizing charts.',
  },
  {
    name: 'Jersey',
    url: 'https://kaspreadsheet.com/category-919-Jersey.html',
    icon: 'ri-trophy-line',
    description: 'Sports jerseys and athletic wear featuring football, basketball, and soccer team editions.',
  },
  {
    name: 'Accessories',
    url: 'https://kaspreadsheet.com/category-920-Accessories.html',
    icon: 'ri-vip-diamond-line',
    description: 'Finish your look with watches, sunglasses, jewelry, and standout accessory pieces.',
  },
  {
    name: 'Bags',
    url: 'https://kaspreadsheet.com/category-921-Bags.html',
    icon: 'ri-briefcase-line',
    description: 'Backpacks, crossbody bags, totes, and luggage finds from budget-friendly to premium tiers.',
  },
  {
    name: 'Belts',
    url: 'https://kaspreadsheet.com/search-922/name/Bags.html',
    icon: 'ri-link',
    description: 'Designer-inspired belts and everyday leather accessories to refine your wardrobe staples.',
  },
  {
    name: 'Perfumes',
    url: 'https://kaspreadsheet.com/search-923/name/Bags.html',
    icon: 'ri-drop-line',
    description: 'Curated fragrance picks and cologne alternatives that capture luxury scents for less.',
  },
  {
    name: 'OtherStuff',
    url: 'https://kaspreadsheet.com/search-924/name/Bags.html',
    icon: 'ri-more-line',
    description: 'Miscellaneous gems, home goods, tech gadgets, and unique finds that do not fit other categories.',
  },
];

export const featuredCategories: Category[] = categories.slice(0, 4);